import Vue from "vue";
import { formatMoney } from "accounting";
import currencySymbol from "currency-symbol-map";

Vue.filter("formatMoney", function (value, currency) {
  if (!value) return "";
  return formatMoney(value, currencySymbol(currency)).replace(".00", "");
});
